<template>
  <div>
    <img v-for="picpart in picparts" :imgpath="getContentImgPath(picpart)" :style="getImgStyle(picSplitCount)"
         v-lazy="require('../../../assets/img/loading.jpeg')"/>
    <br/>
  </div>
</template>

<script>
  import {getImg} from '../../../services/urlService'

  export default {
    name: "readpicture",
    props: {
      picparts: Array,
      picSplitCount: Number
    },
    methods: {
      getContentImg(route) {
        return getImg(`${route}_500_0.img`);
      },
      getContentImgPath(route) {
        return `${route}_500_0.img`;
      },
      getImgStyle(picSplitCount) {
        let eachPicPercent = 100 / picSplitCount;
        return `width: ${eachPicPercent}%; float: left; display: block;`
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/layer2/book/read-picture.vue